import { render } from "./Numbers.vue?vue&type=template&id=a6f3f212&scoped=true"
import script from "./Numbers.vue?vue&type=script&lang=js"
export * from "./Numbers.vue?vue&type=script&lang=js"

import "./Numbers.vue?vue&type=style&index=0&id=a6f3f212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f3f212"]])

export default __exports__